const preload = document.querySelector('#preload');
const anim = document.querySelector('#anim');
const smile = document.querySelector('#smile');
const html = document.querySelector('html');

const changeIcon = (idx, color) => {
  smile.classList.remove(...smile.classList);
  smile.classList.add(`icon-smile-${idx}`, `icon-smile-${idx}--${color}`);
};

const main = () => {
  anim.classList.add('preload__anim--anim');
  html.classList.add('no-scroll');

  setTimeout(() => {
    changeIcon(7, 'yellow');
  }, 1500);

  setTimeout(() => {
    changeIcon(3, 'blue-200');
  }, 2500);

  setTimeout(() => {
    preload.setAttribute('data-visible', 'false');
    html.classList.remove('no-scroll');
  }, 3500);
};

if (localStorage.getItem('lastVisit')) {
  const lastVisit = new Date(localStorage.getItem('lastVisit')).getTime();
  const currentTime = new Date().getTime();
  const timeDifference = currentTime - lastVisit;

  timeDifference > 86400000 && main();
} else {
  preload.setAttribute('data-visible', 'true');
  localStorage.setItem('lastVisit', new Date());
  main();
}
